export enum ServiceModalName {
  ConfirmModal = 'CONFIRMATION_MODAL',
  FormModal = 'FORM_MODAL',
  PrioritizeModal = 'PRIORITIZE_MODAL',
  ViewModal = 'VIEW_MODAL',
}
